<zimmerer-route-ion-wrapper class="ion-page">
    <div class="threecol" fxLayout="column" fxLayoutAlign.gt-md="center center">
        <div class="main-col noSlider" fxLayout="column" fxLayoutGap="20px">
            <!-- breadcrumb -->
            <div>
                <span
                    (click)="StateService.goto('/market')"
                    style="text-decoration: underline; cursor: pointer;"
                    >Marktplatz</span
                >
                > Artikel {{ edit ? "bearbeiten" : "erstellen" }}
            </div>

            <div fxLayout="column" fxLayoutAlign="center center">
                <form [formGroup]="form" *ngIf="form && userService.user">
                    <mat-horizontal-stepper
                        linear
                        #stepper
                        class="createStepper"
                    >
                        <mat-step [completed]="stepsCompleted > 0">
                            <div fxLayout="column" fxLayoutGap="25px">
                                <ng-template matStepLabel
                                    >Anzeige wählen</ng-template
                                >

                                <div>
                                    <div class="title">
                                        {{
                                            Mobileservice.isMobile
                                                ? ""
                                                : "Hier kannst Du einen Marktplatz-Beitrag " +
                                                  (edit
                                                      ? "bearbeiten"
                                                      : "erstellen") +
                                                  "."
                                        }}
                                    </div>
                                    <div class="subtitle">
                                        Verkaufe noch heute was du nicht mehr
                                        brauchst.
                                    </div>
                                </div>

                                <div
                                    fxLayout="column"
                                    fxLayoutGap.lt-lg="20px"
                                    fxLayout.gt-md="row"
                                >
                                    <!-- create as -->
                                    <div fxFlex="grow">
                                        <div class="fat1">Profil</div>
                                        <div
                                            style="margin-top: 0.4375em; margin-bottom: 0.4375em;"
                                        >
                                            <profile-selector [form]="form">
                                            </profile-selector>
                                        </div>
                                    </div>

                                    <!-- separator line -->
                                    <div
                                        *ngIf="!Mobileservice.isMobile"
                                        style="border-right: 1px solid lightgray; margin: 0px 30px;"
                                    ></div>

                                    <div
                                        fxFlex="grow"
                                        fxLayout="column"
                                        fxLayoutGap="15px"
                                    >
                                        <div
                                            fxLayout="column"
                                            fxLayoutGap="10px"
                                        >
                                            <div class="fat1">Anzeigetyp</div>
                                            <mat-radio-group
                                                fxLayout="column"
                                                fxLayoutGap="10px"
                                                formControlName="advertisement_type"
                                                (change)="updateDraft()"
                                            >
                                                <mat-radio-button value="OFFER"
                                                    >Ich biete</mat-radio-button
                                                >
                                                <mat-radio-button value="SEARCH"
                                                    >Ich suche</mat-radio-button
                                                >
                                            </mat-radio-group>
                                        </div>

                                        <div
                                            fxLayout="column"
                                            fxLayoutGap="10px"
                                        >
                                            <div class="fat1">
                                                Ich
                                                {{
                                                    form.get(
                                                        "advertisement_type"
                                                    ).value == "OFFER"
                                                        ? "verkaufe"
                                                        : "suche"
                                                }}
                                                das Produkt / die Dienstleistung
                                            </div>
                                            <mat-radio-group
                                                fxLayout="column"
                                                fxLayoutGap="10px"
                                                formControlName="sale_type"
                                                (change)="updateDraft()"
                                            >
                                                <mat-radio-button
                                                    value="BUSINESS"
                                                    >gewerblich</mat-radio-button
                                                >
                                                <mat-radio-button
                                                    value="PRIVATE"
                                                    >privat</mat-radio-button
                                                >
                                            </mat-radio-group>
                                        </div>
                                    </div>
                                </div>

                                <app-credits-warning
                                    [is_edit]="draft.is_edit"
                                    [profile_type]="
                                        form
                                            ? form.get('profile_type').value
                                            : 'PRIVATE'
                                    "
                                    [entity_type]="'ADVERT'"
                                    [company_profile]="
                                        userService.getCompanyProfile()
                                    "
                                >
                                </app-credits-warning>

                                <div
                                    fxLayout="row"
                                    fxLayoutAlign="end"
                                    fxLayoutGap="10px"
                                >
                                    <button
                                        class="orange-button"
                                        (click)="
                                            nextIfFormValid(false, [
                                                'profile_type'
                                            ])
                                        "
                                    >
                                        {{
                                            draft.is_edit
                                                ? "Speichern und Weiter"
                                                : "Weiter"
                                        }}
                                    </button>
                                </div>
                            </div>
                        </mat-step>

                        <!-- category -->
                        <mat-step [completed]="stepsCompleted > 1">
                            <div fxLayout="column" fxLayoutGap="25px">
                                <ng-template matStepLabel
                                    >Kategorie auswählen</ng-template
                                >

                                <!-- Category -->
                                <mat-form-field>
                                    <app-category-selection
                                        formControlName="category"
                                        [inputCategories]="{
                                            type: CategoryType.marketplace
                                        }"
                                    >
                                    </app-category-selection>
                                </mat-form-field>

                                <mat-error
                                    *ngIf="
                                        (formSubmitted ||
                                            form.get('category').touched) &&
                                        form
                                            .get('category')
                                            .hasError('required')
                                    "
                                >
                                    *Bitte wähle eine Kategorie aus
                                </mat-error>

                                <app-credits-warning
                                    [is_edit]="draft.is_edit"
                                    [profile_type]="
                                        form
                                            ? form.get('profile_type').value
                                            : 'PRIVATE'
                                    "
                                    [entity_type]="'ADVERT'"
                                    [company_profile]="
                                        userService.getCompanyProfile()
                                    "
                                >
                                </app-credits-warning>

                                <div
                                    fxLayout="column"
                                    fxLayoutAlign="start stretch"
                                    fxLayoutGap="10px"
                                    fxLayout.gt-md="row"
                                    fxLayoutAlign.gt-md="end center"
                                >
                                    <button matStepperPrevious>Zurück</button>
                                    <button
                                        class="orange-button"
                                        (click)="
                                            nextIfFormValid(false, ['category'])
                                        "
                                    >
                                        {{
                                            draft.is_edit
                                                ? "Speichern und Weiter"
                                                : "Weiter"
                                        }}
                                    </button>
                                </div>
                            </div>
                        </mat-step>

                        <!-- details -->
                        <mat-step [completed]="stepsCompleted > 2">
                            <ng-template matStepLabel
                                >Details angeben</ng-template
                            >

                            <div fxLayout="column" fxLayoutGap="20px">
                                <!-- Category -->
                                <div
                                    fxLayout="row"
                                    fxLayoutGap="20px"
                                    fxLayout.lt-lg="column"
                                    fxLayoutGap.lt-lg="0px"
                                    *ngIf="draft.category"
                                >
                                    <div
                                        fxFlex="20"
                                        fxLayout="row"
                                        fxLayoutAlign="start center"
                                        class="fieldHeadline"
                                    >
                                        Kategorie
                                    </div>

                                    <div>{{ draft.category.name }}</div>
                                </div>

                                <!-- title -->
                                <div
                                    fxLayout="row"
                                    fxLayoutGap="20px"
                                    fxLayout.lt-lg="column"
                                    fxLayoutGap.lt-lg="0px"
                                >
                                    <div
                                        fxFlex="20"
                                        fxLayout="row"
                                        fxLayoutAlign="start center"
                                        class="fieldHeadline"
                                    >
                                        Titel der Anzeige
                                    </div>

                                    <div class="full-width-input">
                                        <mat-form-field>
                                            <input
                                                matInput
                                                placeholder="Titel"
                                                type="text"
                                                formControlName="title"
                                                (blur)="updateDraft()"
                                            />

                                            <div>
                                                <mat-error
                                                    *ngIf="
                                                        (formSubmitted ||
                                                            form.get('title')
                                                                .touched) &&
                                                        form
                                                            .get('title')
                                                            .hasError(
                                                                'required'
                                                            )
                                                    "
                                                >
                                                    *Titel ist ein
                                                    Pflichtfeld</mat-error
                                                >
                                                <mat-error
                                                    *ngIf="
                                                        (formSubmitted ||
                                                            form.get('title')
                                                                .touched) &&
                                                        form
                                                            .get('title')
                                                            .hasError(
                                                                'minlength'
                                                            )
                                                    "
                                                >
                                                    *Titel muss min. 5 Zeichen
                                                    lang sein</mat-error
                                                >
                                                <mat-error
                                                    *ngIf="
                                                        (formSubmitted ||
                                                            form.get('title')
                                                                .touched) &&
                                                        form
                                                            .get('title')
                                                            .hasError(
                                                                'maxlength'
                                                            )
                                                    "
                                                >
                                                    *Titel darf max. 80 Zeichen
                                                    lang sein</mat-error
                                                >
                                            </div>
                                        </mat-form-field>
                                    </div>
                                </div>

                                <!-- affiliate link - for company profiles only -->
                                <div
                                    fxLayout="row"
                                    fxLayoutGap="20px"
                                    fxLayout.lt-lg="column"
                                    fxLayoutGap.lt-lg="0px"
                                    *ngIf="
                                        form.get('profile_type').value ==
                                            'BUSINESS' &&
                                        form.get('advertisement_type').value ==
                                            'OFFER'
                                    "
                                >
                                    <div
                                        fxFlex="20"
                                        fxLayout="row"
                                        fxLayoutAlign="start center"
                                        class="fieldHeadline"
                                    >
                                        Webseite/Produkt-Link
                                    </div>

                                    <div class="full-width-input">
                                        <mat-form-field>
                                            <input
                                                matInput
                                                placeholder="Link"
                                                type="text"
                                                formControlName="affiliate_link"
                                                (blur)="updateDraft()"
                                            />

                                            <div>
                                                <mat-error
                                                    *ngIf="
                                                        (formSubmitted ||
                                                            form.get(
                                                                'affiliate_link'
                                                            ).touched) &&
                                                        form
                                                            .get(
                                                                'affiliate_link'
                                                            )
                                                            .hasError('pattern')
                                                    "
                                                >
                                                    *Muss eine gültige URL sein
                                                </mat-error>
                                            </div>
                                        </mat-form-field>
                                    </div>
                                </div>

                                <!-- affiliate link button text - for company profiles only -->
                                <div
                                    fxLayout="row"
                                    fxLayoutGap="20px"
                                    fxLayout.lt-lg="column"
                                    fxLayoutGap.lt-lg="0px"
                                    *ngIf="
                                        form.get('profile_type').value ==
                                            'BUSINESS' &&
                                        form.get('advertisement_type').value ==
                                            'OFFER'
                                    "
                                >
                                    <div
                                        fxFlex="20"
                                        fxLayout="row"
                                        fxLayoutAlign="start center"
                                        class="fieldHeadline"
                                    >
                                        Aufschrift zum Link
                                    </div>

                                    <div class="full-width-input">
                                        <mat-form-field>
                                            <input
                                                matInput
                                                placeholder="Buttontext"
                                                type="text"
                                                formControlName="affiliate_link_button_text"
                                                (blur)="updateDraft()"
                                            />
                                        </mat-form-field>
                                    </div>
                                </div>

                                <!-- price / price mode -->
                                <div
                                    fxLayout="row"
                                    fxLayoutGap="20px"
                                    fxLayout.lt-lg="column"
                                    fxLayoutGap.lt-lg="0px"
                                >
                                    <div
                                        fxFlex="20"
                                        fxLayout="row"
                                        fxLayoutAlign="start center"
                                        class="fieldHeadline"
                                    >
                                        Preis in EUR
                                    </div>

                                    <mat-form-field>
                                        <input
                                            matInput
                                            placeholder="Preis"
                                            type="text"
                                            formControlName="price"
                                            (blur)="updateDraft()"
                                        />

                                        <div>
                                            <mat-error
                                                *ngIf="
                                                    (formSubmitted ||
                                                        form.get('price')
                                                            .touched) &&
                                                    form.hasError(
                                                        'price_pattern'
                                                    )
                                                "
                                            >
                                                *Bitte geben sie einen gültigen
                                                Betrag ein z.B. 12,55
                                            </mat-error>
                                            <mat-error
                                                *ngIf="
                                                    (formSubmitted ||
                                                        form.get('price')
                                                            .touched) &&
                                                    form.hasError(
                                                        'price_required'
                                                    )
                                                "
                                            >
                                                *Preis ist ein Pflichtfeld
                                            </mat-error>
                                            <mat-error
                                                *ngIf="
                                                    (formSubmitted ||
                                                        form.get('price')
                                                            .touched) &&
                                                    form.hasError('price_max')
                                                "
                                            >
                                                *Der Preis ist zu hoch
                                            </mat-error>
                                        </div>
                                    </mat-form-field>

                                    <mat-form-field>
                                        <mat-select
                                            formControlName="price_mode"
                                            (selectionChange)="
                                                updateSelectedPriceMode();
                                                updateDraft()
                                            "
                                        >
                                            <mat-option value="FIXED_PRICE"
                                                >Festpreis</mat-option
                                            >
                                            <mat-option
                                                value="NEGOTIATING_BASIS"
                                                >Verhandlungsbasis</mat-option
                                            >
                                            <mat-option value="PRICE_ON_REQUEST"
                                                >Auf Anfrage</mat-option
                                            >
                                        </mat-select>

                                        <div>
                                            <mat-error
                                                class="form-validation-error"
                                                *ngIf="
                                                    (formSubmitted ||
                                                        form.get('price_mode')
                                                            .touched) &&
                                                    form
                                                        .get('price_mode')
                                                        .hasError('required')
                                                "
                                            >
                                                *Preismodus ist ein Pflichtfeld
                                            </mat-error>
                                        </div>
                                    </mat-form-field>
                                </div>

                                <!-- Condition -->
                                <div
                                    fxLayout="row"
                                    fxLayoutGap="20px"
                                    fxLayout.lt-lg="column"
                                    fxLayoutGap.lt-lg="0px"
                                >
                                    <div
                                        fxFlex="20"
                                        fxLayout="row"
                                        fxLayoutAlign="start center"
                                        class="fieldHeadline"
                                    >
                                        Zustand
                                    </div>

                                    <mat-radio-group
                                        fxLayout="row"
                                        fxLayoutGap="10px"
                                        formControlName="condition"
                                        style="padding: 0.4375em 0;"
                                    >
                                        <mat-radio-button
                                            value="NEW"
                                            (change)="updateDraft()"
                                            >Neu</mat-radio-button
                                        >
                                        <mat-radio-button
                                            value="USED"
                                            (change)="updateDraft()"
                                            >Gebraucht</mat-radio-button
                                        >
                                    </mat-radio-group>

                                    <div>
                                        <mat-error
                                            *ngIf="
                                                (formSubmitted ||
                                                    form.get('condition')
                                                        .touched) &&
                                                form
                                                    .get('condition')
                                                    .hasError('required')
                                            "
                                        >
                                            *Bitte wähle einen Zustand
                                            aus</mat-error
                                        >
                                    </div>
                                </div>

                                <!-- Location -->
                                <div
                                    fxLayout="row"
                                    fxLayoutGap="20px"
                                    fxLayout.lt-lg="column"
                                    fxLayoutGap.lt-lg="0px"
                                >
                                    <div
                                        fxFlex="20"
                                        fxLayout="row"
                                        fxLayoutAlign="start center"
                                        class="fieldHeadline"
                                    >
                                        Standort
                                    </div>

                                    <!-- old @angular-material-extensions/google-maps-autocomplete autocomplete -->
                                    <!-- <mat-form-field>
                  <input matInput
                    type="number"
                    formControlName="zip"
                    matGoogleMapsAutocomplete
                    [types]="['geocode']"
                    [country]="['de','at','ch']"
                    placeholder="PLZ"
                    (onAutocompleteSelected)="onAutocompleteSelected($event)"
                    (onLocationSelected)="onLocationSelected($event)"
                    (blur)="updateDraft()">
                </mat-form-field> -->

                                    <!-- FIELDs WITHOUT GOOGLE COMPLETION -->
                                    <mat-form-field>
                                        <input
                                            matInput
                                            type="text"
                                            formControlName="zip"
                                            placeholder="PLZ"
                                            (blur)="updateDraft()"
                                        />
                                    </mat-form-field>

                                    <mat-form-field>
                                        <input
                                            matInput
                                            type="text"
                                            formControlName="city"
                                            placeholder="Ort"
                                            (blur)="updateDraft()"
                                        />
                                    </mat-form-field>
                                </div>

                                <!-- Delivery -->
                                <div
                                    fxLayout="row"
                                    fxLayoutGap="20px"
                                    fxLayout.lt-lg="column"
                                    fxLayoutGap.lt-lg="0px"
                                >
                                    <div
                                        fxFlex="20"
                                        fxLayout="row"
                                        fxLayoutAlign="start center"
                                        class="fieldHeadline"
                                    >
                                        Versand
                                    </div>

                                    <div style="padding: 0.4375em 0;">
                                        <checkbox-group
                                            formControlName="delivery"
                                            (ngModelChange)="updateDraft()"
                                        >
                                        </checkbox-group>

                                        <div>
                                            <mat-error
                                                *ngIf="
                                                    (formSubmitted ||
                                                        form.controls.delivery
                                                            .touched) &&
                                                    form.controls.delivery.hasError(
                                                        'required'
                                                    )
                                                "
                                            >
                                                *Bitte wähle mindestens eins aus
                                            </mat-error>
                                            <mat-error
                                                *ngIf="
                                                    (formSubmitted ||
                                                        form.get('delivery')
                                                            .touched ||
                                                        form.get('city')
                                                            .touched ||
                                                        form.get('zip')
                                                            .touched) &&
                                                    form.hasError(
                                                        'locationRequired'
                                                    )
                                                "
                                            >
                                                *Bei Selbstabholung ist PLZ und
                                                Ort Pflichtfeld
                                            </mat-error>
                                        </div>
                                    </div>
                                </div>

                                <!-- main image -->
                                <div
                                    fxLayout="row"
                                    fxLayoutGap="20px"
                                    fxLayout.lt-lg="column"
                                    fxLayoutGap.lt-lg="0px"
                                >
                                    <mat-form-field style="display: none;">
                                        <app-image-formcontrol
                                            matInput
                                            formControlName="mainImage"
                                        ></app-image-formcontrol>
                                    </mat-form-field>

                                    <div
                                        fxFlex="20"
                                        fxLayout="row"
                                        fxLayoutAlign="start center"
                                        class="fieldHeadline"
                                    >
                                        Hauptbild
                                    </div>

                                    <div style="padding: 0.4375em 0;">
                                        <div
                                            *ngIf="draft.mainImage"
                                            style="margin-bottom: 10px;"
                                        >
                                            <edit-images
                                                *ngIf="draft.mainImage"
                                                [images]="[draft.mainImage]"
                                                [deleteImage]="deleteImage.bind(this)"
                                                [key]="'MAIN,SLIDE'"
                                            ></edit-images>
                                        </div>

                                        <image-upload-box
                                            *ngIf="!draft.mainImage"
                                            [fileSelected]="fileSelected.bind(this)"
                                            [fileDropped]="fileDropped.bind(this)"
                                            [key]="'MAIN,SLIDE'"
                                            [multiple]="false"
                                        >
                                        </image-upload-box>

                                        <mat-error
                                            *ngIf="
                                                (mainImageDeleted&&!draft.mainImage) || (formSubmitted ||
                                                    form.get('mainImage')
                                                        .touched) &&
                                                form.hasError(
                                                    'mainImage_required'
                                                ) 
                                            "
                                        >
                                            *Bitte laden Sie ein Hauptbild hoch.
                                        </mat-error>
                                    </div>
                                </div>

                                <!-- other images -->
                                <div
                                    fxLayout="row"
                                    fxLayoutGap="20px"
                                    fxLayout.lt-lg="column"
                                    fxLayoutGap.lt-lg="0px"
                                >
                                    <div
                                        fxFlex="20"
                                        fxLayout="row"
                                        fxLayoutAlign="start center"
                                        class="fieldHeadline"
                                    >
                                        Weitere Bilder
                                    </div>

                                    <div style="padding: 0.4375em 0;">
                                        <div
                                            *ngIf="draft.images"
                                            style="margin-bottom: 10px;"
                                        >
                                            <edit-images
                                                [images]="draft.images"
                                                [deleteImage]="deleteImage.bind(this)"
                                                [key]="'SLIDE'"
                                            >
                                            </edit-images>
                                        </div>

                                        <image-upload-box
                                            [fileSelected]="fileSelected.bind(this)"
                                            [fileDropped]="fileDropped.bind(this)"
                                            [key]="'SLIDE'"
                                        >
                                        </image-upload-box>
                                    </div>
                                </div>

                                <!-- content -->
                                <div
                                    fxLayout="row"
                                    fxLayoutGap="20px"
                                    fxLayout.lt-lg="column"
                                    fxLayoutGap.lt-lg="0px"
                                >
                                    <div
                                        fxFlex="20"
                                        fxLayout="row"
                                        fxLayoutAlign="start center"
                                        class="fieldHeadline"
                                    >
                                        Beschreibungstext
                                    </div>

                                    <div
                                        fxFlex="grow"
                                        style="padding: 0.4375em 0;"
                                    >
                                        <editor
                                            apiKey="cirw0hv94c52sgyqp5rseuz1djp09a8nptls2c9a41ypi805"
                                            [init]="tinyDefaultConfig"
                                            [formControlName]="'content'"
                                            (onBlur)="updateDraft()"
                                        >
                                        </editor>

                                        <div>
                                            <mat-error
                                                *ngIf="
                                                    (formSubmitted ||
                                                        form.get('content')
                                                            .touched) &&
                                                    form
                                                        .get('content')
                                                        .hasError('required')
                                                "
                                            >
                                                *Beschreibungstext ist ein
                                                Pflichtfeld
                                            </mat-error>
                                        </div>
                                    </div>
                                </div>

                                <div
                                    fxLayout="row"
                                    fxLayoutAlign="end"
                                    fxLayoutGap="10px"
                                >
                                    <div *ngIf="formSubmitted && form.invalid">
                                        <div class="form-validation-error">
                                            Bitte prüfe deine Eingaben.
                                        </div>
                                    </div>
                                </div>

                                <app-credits-warning
                                    [is_edit]="draft.is_edit"
                                    [profile_type]="
                                        form
                                            ? form.get('profile_type').value
                                            : 'PRIVATE'
                                    "
                                    [entity_type]="'ADVERT'"
                                    [company_profile]="
                                        userService.getCompanyProfile()
                                    "
                                >
                                </app-credits-warning>

                                <!-- action buttons -->
                                <div
                                    fxLayout="column"
                                    fxLayoutAlign="start stretch"
                                    fxLayoutGap="10px"
                                    fxLayout.gt-md="row"
                                    fxLayoutAlign.gt-md="end center"
                                >
                                    <button matStepperPrevious>Zurück</button>
                                    <button
                                        class="orange-button"
                                        (click)="nextIfFormValid(false)"
                                    >
                                        {{
                                            draft.is_edit
                                                ? "Speichern und Weiter"
                                                : "Weiter"
                                        }}
                                    </button>
                                </div>
                            </div>
                        </mat-step>

                        <!-- preview -->
                        <mat-step
                            label="preview"
                            fxLayout="column"
                            fxLayoutGap="10px"
                            [completed]="stepsCompleted > 3"
                        >
                            <ng-template matStepLabel>
                                Vorschau
                            </ng-template>

                            <div fxHide.gt-md>
                                {{ draft.is_edit ? "Vorschau" : "Anzeige" }}
                            </div>

                            <div fxLayout="column" fxLayoutGap="20px">
                                <app-advert-display
                                    *ngIf="currentStepLabel == 'preview'"
                                    [entity]="draft"
                                    [live]="false"
                                >
                                </app-advert-display>

                                <app-credits-warning
                                    [is_edit]="draft.is_edit"
                                    [profile_type]="
                                        form
                                            ? form.get('profile_type').value
                                            : 'PRIVATE'
                                    "
                                    [entity_type]="'ADVERT'"
                                    [company_profile]="
                                        userService.getCompanyProfile()
                                    "
                                >
                                </app-credits-warning>

                                <div
                                    fxLayout="column"
                                    fxLayoutGap="10px"
                                    fxLayout.gt-sm="row"
                                    fxLayoutAlign.gt-sm="end"
                                >
                                    <button matStepperPrevious>Zurück</button>
                                    <button
                                        class="orange-button"
                                        (click)="publish()"
                                        *ngIf="!draft.is_edit"
                                    >
                                        Veröffentlichen
                                    </button>
                                    <button
                                        class="orange-button"
                                        (click)="gotoDetail()"
                                        *ngIf="draft.is_edit"
                                    >
                                        Speichern und Weiter
                                    </button>
                                </div>
                            </div>
                        </mat-step>

                        <!-- SUCCESS -->
                        <mat-step
                            label="last step"
                            *ngIf="!draft.is_edit"
                            [completed]="stepsCompleted > 4"
                        >
                            <ng-template matStepLabel>Geschafft!</ng-template>

                            <div fxLayout="column" fxLayoutGap="20px">
                                <ng-container
                                    *ngIf="
                                        draft.accepted_by_admin;
                                        else waitForApproval
                                    "
                                >
                                    <div>
                                        <b>Geschafft!</b><br />
                                        Deine Anzeige wird in Kürze online sein!
                                    </div>

                                    <div>
                                        <p>Inserat teilen:</p>

                                        <share-buttons
                                            [include]="
                                                mobileService.isMobile
                                                    ? appConfig.shareconfig_mobile
                                                    : appConfig.shareconfig_desktop
                                            "
                                            [show]="appConfig.sharebuttonsmax"
                                            [showText]="true"
                                            [url]="draft.getOpgraphData().url"
                                            [autoSetMeta]="false"
                                            description=" "
                                        >
                                        </share-buttons>
                                    </div>
                                </ng-container>

                                <ng-template #waitForApproval>
                                    <div>
                                        <b>Geschafft!</b><br />
                                        Deine Anzeige wird geprüft und in Kürze
                                        online sein!<br />
                                        Du wirst über Email benachrichtigt,
                                        sobald die Anzeige online ist.
                                    </div>
                                </ng-template>

                                <div
                                    fxLayout="row"
                                    fxLayout.lt-lg="column"
                                    fxLayoutAlign="end center"
                                    fxLayoutGap="10px"
                                >
                                    <button
                                        class="dark-grey-button"
                                        (click)="goToCreate()"
                                    >
                                        <span fxHide.lt-lg="true"
                                            >Weitere Anzeige erstellen</span
                                        >
                                        <span fxHide.gt-md="true"
                                            >Weitere Anzeige</span
                                        >
                                    </button>
                                    <button
                                        class="dark-grey-button"
                                        (click)="goBackToList()"
                                    >
                                        <span fxHide.lt-lg="true"
                                            >Zurück zur Übersicht</span
                                        >
                                        <span fxHide.gt-md="true"
                                            >Zur Übersicht</span
                                        >
                                    </button>
                                </div>
                            </div>

                            <!--<p>Das könnte dich auch interessieren</p>
            <advert-related-items [direction]="'horizontal'"></advert-related-items> -->
                        </mat-step>
                    </mat-horizontal-stepper>
                </form>
            </div>

            <!-- mostviewed -->
            <div>
                <advert-related-items
                    [direction]="'horizontal'"
                    [items]="mostViewed"
                    [title]="'Das könnte dich auch interessieren'"
                    *ngIf="
                        mostViewed &&
                        mostViewed.length > 0 &&
                        currentStepLabel == 'last step'
                    "
                    style="width: 100%;"
                ></advert-related-items>
            </div>
        </div>
    </div>
</zimmerer-route-ion-wrapper>
